var posts = {
    init: function() {
        var self = this,
        $loadMoreContainer = $( '[data-load-more="container"]' ),
        $loadMoreTrigger = $( '[data-load-more="trigger"]' ),
        $loadMoreTriggerDefaultText = $loadMoreTrigger.html(),
        $loadMoreTriggerLoadingText = $loadMoreTrigger.attr( 'data-load-text' );

        var page = 1,
        loading  = false;

		$loadMoreTrigger.on( 'click', function(e) {
			e.preventDefault();

			var $this = $( this );
			page = page + 1;

			if ( loading === true ) {
				return;
			}

			var data = {
				action: 'load_more_posts',
				page: page
			}

			loading = true;
			$this.addClass( 'loading' );
			$this.html( $loadMoreTriggerLoadingText );

			jQuery.post( themeVars.ajax_url, data, function( response ) {
				$loadMoreContainer.append( response.data.posts );
				loading = false;

				if ( true == response.data.finish ) {
					$this.parent().remove();
				} else {
					$this.removeClass( 'loading' );
					$this.html( $loadMoreTriggerDefaultText );
				}
			} );
		} );             
    },
}

export {
    posts
};
